import { render, staticRenderFns } from "./study-participant-compose-message.vue?vue&type=template&id=00f7f65c&scoped=true&"
import script from "./study-participant-compose-message.vue?vue&type=script&lang=js&"
export * from "./study-participant-compose-message.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=00f7f65c&scoped=true&lang=scss&"
import style1 from "./study-participant-compose-message.vue?vue&type=style&index=1&id=00f7f65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f7f65c",
  null
  
)

component.options.__file = "study-participant-compose-message.vue"
export default component.exports